/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ServiceDndSubscription } from '../model/serviceDndSubscription';
import { SubscriberServiceDndStatus } from '../model/subscriberServiceDndStatus';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServiceDndSubscriptionService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param phoneNumber 
     * @param serviceCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceDndSubscriptionGetServiceDndSubscriberByPhoneNumberAndServiceCodeGet(phoneNumber?: string, serviceCode?: string, observe?: 'body', reportProgress?: boolean): Observable<SubscriberServiceDndStatus>;
    public apiServiceDndSubscriptionGetServiceDndSubscriberByPhoneNumberAndServiceCodeGet(phoneNumber?: string, serviceCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscriberServiceDndStatus>>;
    public apiServiceDndSubscriptionGetServiceDndSubscriberByPhoneNumberAndServiceCodeGet(phoneNumber?: string, serviceCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscriberServiceDndStatus>>;
    public apiServiceDndSubscriptionGetServiceDndSubscriberByPhoneNumberAndServiceCodeGet(phoneNumber?: string, serviceCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (serviceCode !== undefined && serviceCode !== null) {
            queryParameters = queryParameters.set('serviceCode', <any>serviceCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SubscriberServiceDndStatus>('get',`${this.basePath}/api/ServiceDndSubscription/GetServiceDndSubscriberByPhoneNumberAndServiceCode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phonenumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceDndSubscriptionGetServiceDndSubscriberByPhoneNumberGet(phonenumber?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SubscriberServiceDndStatus>>;
    public apiServiceDndSubscriptionGetServiceDndSubscriberByPhoneNumberGet(phonenumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SubscriberServiceDndStatus>>>;
    public apiServiceDndSubscriptionGetServiceDndSubscriberByPhoneNumberGet(phonenumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SubscriberServiceDndStatus>>>;
    public apiServiceDndSubscriptionGetServiceDndSubscriberByPhoneNumberGet(phonenumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (phonenumber !== undefined && phonenumber !== null) {
            queryParameters = queryParameters.set('phonenumber', <any>phonenumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SubscriberServiceDndStatus>>('get',`${this.basePath}/api/ServiceDndSubscription/GetServiceDndSubscriberByPhoneNumber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceDndSubscriptionGetServiceDndSubscriberByServiceCodeGet(serviceCode?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiServiceDndSubscriptionGetServiceDndSubscriberByServiceCodeGet(serviceCode?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiServiceDndSubscriptionGetServiceDndSubscriberByServiceCodeGet(serviceCode?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiServiceDndSubscriptionGetServiceDndSubscriberByServiceCodeGet(serviceCode?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceCode !== undefined && serviceCode !== null) {
            queryParameters = queryParameters.set('serviceCode', <any>serviceCode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/ServiceDndSubscription/GetServiceDndSubscriberByServiceCode`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceDndSubscriptionProcessServiceDndSubscriptionListPost(body?: Array<SubscriberServiceDndStatus>, observe?: 'body', reportProgress?: boolean): Observable<Array<SubscriberServiceDndStatus>>;
    public apiServiceDndSubscriptionProcessServiceDndSubscriptionListPost(body?: Array<SubscriberServiceDndStatus>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SubscriberServiceDndStatus>>>;
    public apiServiceDndSubscriptionProcessServiceDndSubscriptionListPost(body?: Array<SubscriberServiceDndStatus>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SubscriberServiceDndStatus>>>;
    public apiServiceDndSubscriptionProcessServiceDndSubscriptionListPost(body?: Array<SubscriberServiceDndStatus>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<SubscriberServiceDndStatus>>('post',`${this.basePath}/api/ServiceDndSubscription/ProcessServiceDndSubscriptionList`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceDndSubscriptionProcessServiceDndSubscriptionPost(body?: SubscriberServiceDndStatus, observe?: 'body', reportProgress?: boolean): Observable<SubscriberServiceDndStatus>;
    public apiServiceDndSubscriptionProcessServiceDndSubscriptionPost(body?: SubscriberServiceDndStatus, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscriberServiceDndStatus>>;
    public apiServiceDndSubscriptionProcessServiceDndSubscriptionPost(body?: SubscriberServiceDndStatus, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscriberServiceDndStatus>>;
    public apiServiceDndSubscriptionProcessServiceDndSubscriptionPost(body?: SubscriberServiceDndStatus, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SubscriberServiceDndStatus>('post',`${this.basePath}/api/ServiceDndSubscription/ProcessServiceDndSubscription`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiServiceDndSubscriptionServiceDndSubscriptionInsertPost(body?: ServiceDndSubscription, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiServiceDndSubscriptionServiceDndSubscriptionInsertPost(body?: ServiceDndSubscription, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiServiceDndSubscriptionServiceDndSubscriptionInsertPost(body?: ServiceDndSubscription, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiServiceDndSubscriptionServiceDndSubscriptionInsertPost(body?: ServiceDndSubscription, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/ServiceDndSubscription/ServiceDndSubscriptionInsert`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
